import React, { useCallback } from 'react';

import { CalculatedLine, Component } from '@paragon/contract-library';

import { useAppDispatch } from '../../../components/hooks';
import { onClickIntersectionDuringBasicInsertion } from '../../../store/actions/basicInsertionActions';
import { BasicLineDefinition, ReferenceLineIntersection } from '../../../store/slices/applicationSlice';
import { ReferenceLineIntersections } from '../ReferenceLineIntersections';
import { BasicInsertionPreviewVisuals } from './BasicInsertionPreviewVisuals';

interface Props {
  readonly component: Component;
  readonly visibleReferenceLines: readonly CalculatedLine[];
  readonly basicLineDefinition: BasicLineDefinition;
  readonly hoveredLineGuids: ReadonlySet<string>;
}

export function BasicInsertionController({
  component,
  visibleReferenceLines,
  basicLineDefinition,
  hoveredLineGuids,
}: Props) {
  const dispatch = useAppDispatch();

  const onClickIntersection = useCallback(
    (intersection: ReferenceLineIntersection) => {
      dispatch(onClickIntersectionDuringBasicInsertion(intersection));
    },
    [dispatch],
  );

  return (
    <ReferenceLineIntersections
      component={component}
      visibleReferenceLines={visibleReferenceLines}
      onClickIntersection={onClickIntersection}
    >
      {(hoveredIntersection) =>
        basicLineDefinition.firstSelection ? (
          // this is a preview visual, so only relevant after the first selection has been made
          <BasicInsertionPreviewVisuals
            definition={basicLineDefinition}
            hoveredIntersection={hoveredIntersection}
            hoveredLineGuids={hoveredLineGuids}
          />
        ) : null
      }
    </ReferenceLineIntersections>
  );
}
